"use strict";

import createWellQuantity from "./createWellQuantity";

export default function scalarToQuantity(dataTypeStore, unitAssignment, scalar){
	
	var application = dataTypeStore.get(scalar.dataType).applicationType;
	var representationType = dataTypeStore.get(scalar.dataType).representationType;
	var originalUnit = dataTypeStore.get(scalar.dataType).unit;
	
	return createWellQuantity(unitAssignment, application, scalar.value, originalUnit, representationType);
}


// WEBPACK FOOTER //
// ./~/vwa/quantity/scalarToQuantity.js